const initialState = {
  title: ''
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_TITLE':
      return { title: action.payload };
    default:
      return state;
  }
};

export default reducer;
